import { Span } from '@components/Components/Reusables/Typography/P';
import Spinner from '@components/Components/Spinners/Spinner';
import { capitalizeFirstLetter } from '@components/config/helpers';
import useAPI from '@components/_hooks/useApi'
import Image from 'next/image';
import React, { useEffect } from 'react'
import ProductPackageCoreOption from './ProductPackageCoreOption';


export default function ProductPackageCore(props) {

    const {
        product, 
        selectedPackage, 
        setSelectedPackage, 
        setSelectedPackageData, 
        setMasterPackage,
        set_extra_image_set,
        set_thumbnail_images
    } = props;

    const {data, error, isLoading } = useAPI(`package-core/get-package-core?package_core_group_id=${product.package_core_group_id}&brand=${process.env.brand.brand_key}`, {
        revalidateIfStale: true,
        revalidateOnFocus: false,
        dedupingInterval: 300000
    });
    
    const formatPackages = () => {
        const bulkBuilder = [];
        const active_package_index = data?.findIndex(package_item => package_item.package_core_id == selectedPackage);


        if(active_package_index != null){
            const options = data[active_package_index]?.package_core_options || [];
            set_extra_image_set(data[active_package_index]?.extra_images?.[0]?.zoom_image || null)
            options.map(option => bulkBuilder.push({
                slug: option.product_slug,
                qty: option.package_core_option_default_value,
                package_core_option_id: option.package_core_option_id,
                name: option.package_core_option_section_name,
                multiplier: data[active_package_index].multiplier,
                finish_multiplier: option.finish_multiplier
            }))
            setMasterPackage(bulkBuilder);
        }
    }

    function setImage(package_core_id){
        const active_package_index = data?.findIndex(package_item => package_item.package_core_id == package_core_id)
        if(data[active_package_index]?.extra_images?.length > 0){
            const newImage = data[active_package_index].extra_images[0].zoom_image;
            set_extra_image_set(newImage)
        }
        // set_extra_image_set(package_item_image)
    }

    useEffect(() => {
        data?.[0]?.package_core_id && setSelectedPackage(data[0].package_core_id);
        if(data){
            const newImages = [];
            data?.forEach(package_core => {
                if(package_core?.extra_images[0]?.zoom_image){
                    const image = package_core?.extra_images[0]?.zoom_image;
                    newImages.push(image);
                }
            })
            set_thumbnail_images(newImages);
        }
    }, [data])

    useEffect(() => {
        formatPackages();
     }, [selectedPackage, data])
    

    return (
        <div>
            <Span className="fw-bold fs-18" color="secondary">Choose configuration:</Span>
            {isLoading && (<><br/><Spinner /></>)}
            {data && data.length > 0 && (
                <div className="package-core-grid2">
                    <br/>
                    {data.map((data, idx) => (
                        <figure className="mb-0 mr-0 ml-0 mt-0 mb-8" key={idx}>
                            <div className="package-core-grid">
                                <div 
                                    onClick={() => {
                                        setSelectedPackageData(data),
                                        setSelectedPackage(data.package_core_id),
                                        setImage(data.package_core_id);
                                    }}
                                    className={`pointer package-core-box ${selectedPackage == data.package_core_id ? 'bg-secondary package-core-box-active' : ''} package-core-grid-item`} 
                                    style={{display: 'grid', alignContent: 'space-around'}}
                                >
                                    <Span className="text-center fw-bold">{capitalizeFirstLetter(data.package_core_title.toLowerCase())}</Span>
                                    <div className='margin-auto'>
                                        <Image
                                            style={{
                                                objectFit: 'contain'
                                            }}
                                            height={180}
                                            width={180}
                                            src={data.image}
                                            alt={"Alt Image"}
                                        />
        
                                    </div>
                                    <Span className="text-center">{data.package_core_subtitle}</Span>
                                </div>
                                <div className="align-content-center" style={{ marginTop: '-18px'}}>
                                    <div className='vertical-auto margin-auto'>
                                        {
                                            data.package_core_options.map((core_option, idx) => (
                                                <ProductPackageCoreOption 
                                                    disabled={selectedPackage != data.package_core_id || core_option.package_core_option_fixed_value != null}
                                                    key={idx}
                                                    package_core={data}
                                                    core_option={core_option}
                                                    setMasterPackage={setMasterPackage}
                                                    selectedPackage={selectedPackage}
                                                />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </figure>
                    ))}
                </div>
            )}

        </div>
    )
}
